import { ApiError, apiClient } from 'shared/api';

import {
  CheckWithYouApplyLinkResponse,
  CheckWithYouOrderDetailResponse,
  CheckWithYouOrderHistoryResponse,
} from '../model/dto';

export const getCheckWithYouOrderHistory = async (): Promise<CheckWithYouOrderHistoryResponse[]> => {
  const { data } = await apiClient.get('/checkservice/CHECK_WITH_YOU/order-history');

  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data.result;
};

/**
 * 상세는 주문번호가 아니라 신청번호로 조회한다.
 * 부가서비스 공통 상세(`/checkservice/{orderId}`)는 주문 기준인데, 이 서비스는 주문 자체가 없다.
 */
export const getCheckWithYouDetail = async (
  checkWithYouId: number | string,
): Promise<CheckWithYouOrderDetailResponse> => {
  const { data } = await apiClient.get(`/cwy/${checkWithYouId}`);

  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data.result;
};

/**
 * 로그인 회원용 신청 폼 링크. 서명된 회원 토큰이 실려 있어 제출한 신청이 그 회원에게 확실히 연결된다.
 * 폼 주소를 그냥 열면 이메일 매칭에 기대게 되므로, 로그인 상태에서는 반드시 이 링크로 연다.
 */
export const getCheckWithYouApplyLink = async (): Promise<CheckWithYouApplyLinkResponse> => {
  const { data } = await apiClient.get('/cwy/apply-link');

  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data.result;
};
